import React, {FC,useRef,useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Container, Grid } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import AdminHeader from "../SubComponents/AdminHeader";
import Footer from "../SubComponents/Footer";
import BasicInformation from "./BasicInformation";
import VerificationDetails from "./VerificationDetails";
import CaptureType from "./CaptureType";
import MobileBullets from "../SubComponents/MobileBullets";
import { TabsProps } from "../../interfaces";
import {KYCStyles} from "../Styles/IdentityVerificationStyles";

const TabPanel: FC<TabsProps> = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index: number) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}


const IdentityVerification:FC = () => {
  const classes = KYCStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const scrolldiv = useRef(null);

  return (
    <>
      <AdminHeader />
      <Box className={classes.profilesetting} component="section">
        <Container fixed>
          <Grid>
            <Grid item md={12}>
              <Box mb={isActiveXS ? 3 : 5} p={0}>
                <Typography variant="h2" color="primary">
                  Identity{" "}
                  <Typography component="span" variant="h2" color="secondary">
                    Verification
                  </Typography>
                </Typography>
              </Box>
              <div id="scrolldiv" ref={scrolldiv} className={classes.root}>
                <Tabs
                  value={value}
                  textColor="secondary"
                  indicatorColor="secondary"
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons={isActive ? "on" : "off"}
                  aria-label="scrollable auto tabs example"
                >
                  <Tab label="Basic Information" {...a11yProps(0)} />
                  <Tab label="Verification Detail" {...a11yProps(1)} />
                  <Tab label="Capture Type" {...a11yProps(2)} />
                </Tabs>

                <TabPanel value={value} index={0}>
                  <BasicInformation />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <VerificationDetails />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <CaptureType />
                </TabPanel>
              </div>
              {isActive ? (
                <Box mt={2}>
                <MobileBullets value={value} handleChange={handleChange} bullets={[1,2,3]} scroll={scrolldiv} />
                </Box>
              ) : ''}
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};
export default IdentityVerification;
